var symphony = symphony || {};

;
(function () {

	symphony.scrollToNextSection = function () {

		$('.js-scrollNextSection').on('click', function (e) {
			e.preventDefault();
			performScroll();
		});
		$('.js-scrollNextSection').on('keypress', function (e) {
			if (e.keyCode == 13) {
				e.preventDefault();
				performScroll();
			}
		});

		function performScroll() {
			//var nextDiv = $(this).parent().next('.section');
			//var headerHeight = 50;
			// var $globalHeader = $('.globalHeader');
			// var $givingToolbar = $('.givingToolbar-toolbar');

			$("html, body").animate({
				scrollTop: $('.heroContainer').outerHeight()
			}, 500, function () {
				// $globalHeader.addClass('isSticky');
				// $givingToolbar.addClass('navbar-fixed');
			});
		}

	};


})();
